import { downloadPublicShareZip } from '@/api/document.api';

export async function savePublicShareZip(code: string, name: string, folderId?: number, sessionToken?: string) {
  const response = await downloadPublicShareZip(code, folderId, sessionToken);
  const url = URL.createObjectURL(response.data);
  const anchor = document.createElement('a');
  try {
    anchor.href = url;
    anchor.download = `${name.replace(/[\\/:*?"<>|\x00-\x1f]/g, '_') || 'folder'}.zip`;
    document.body.appendChild(anchor);
    anchor.click();
  } finally {
    anchor.remove();
    // Give the browser time to start reading the object URL before releasing it.
    window.setTimeout(() => URL.revokeObjectURL(url), 1000);
  }
}

export async function publicShareFailure(error: unknown): Promise<{ status?: number; message?: string }> {
  const response = (error as { response?: { status?: number; data?: Blob | { message?: string } } })?.response;
  if (response?.data instanceof Blob) {
    try {
      const data = JSON.parse(await response.data.text());
      return { status: response.status, message: typeof data.message === 'string' ? data.message : undefined };
    } catch {
      return { status: response.status };
    }
  }
  return { status: response?.status, message: response?.data?.message };
}
